export default __webpack_public_path__ + "static/kingdom_school_small_video_Mobi-27d93ff9973d05771997d13f7e5f5e7a.mp4";